// import Image from 'next/image'
import { Container, Row, Col } from 'reactstrap'
import classNames from 'classnames';
import { Benefit } from './benefit';
import { Section } from '../Sections'
import { Icon } from '../Icon'
import { RichText } from 'prismic-reactjs';

interface Props {
  benefits: Array<Benefit>,
  benefit: Array<Benefit>,
}

interface Benefit {
  benefits__icon: any,
  benefits__title: any,
  benefits__text: any,
}

export const BenefitsFlexLiving:  React.FunctionComponent<Props> = ({ benefits }) => {
  return (
    <Section hasBottom={ false }>
      <div className={ 'benefits-section' }>
        <Container fluid>
          <Row>
            { benefits && benefits.map((benefit, key) =>
              <Benefit
                key={ key }
                icon={ <Icon type={ benefit.benefits__icon } /> }
                title={ RichText.asText(benefit.benefits__title) }
                text={ RichText.asText(benefit.benefits__text) }
                headlineSize='lg'
                fullCols
              />
            )}
          </Row>
        </Container>
      </div>
    </Section>
  )
}